/**
 *
 * DocumentsOverviewThumb
 *
 */

import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';
// import clsx from 'clsx';
import { DOCUMENTS_PAGE } from 'lib/routes';
import { FormattedMessage, FormattedDateTime } from 'lib/intl';

// api
import { InvoiceContainerWithoutInvoiceDetections } from 'lib/api/invoiceContainer';
import { InvoicePage } from 'lib/api/invoice';
import { generateImageURL } from 'lib/api/images';

// decorate
import { decorate, Decorate } from './decorate';

import { CheckmarkIcon } from 'lib/ui/Icons';

export interface DocumentsOverviewThumbProps {
  document: InvoiceContainerWithoutInvoiceDetections;
  sizeFactor: number;
  selectDocument: (containerId: string, invoiceId: string) => any;
  isSelected: boolean;
  showSelectCheckbox: boolean;
}

const DocumentsOverviewThumb: React.FC<DocumentsOverviewThumbProps & Decorate> = (props) => {
  const { classes, sizeFactor, document, selectDocument, isSelected, showSelectCheckbox } = props;

  // flat pages array
  const pages = useMemo<(InvoicePage & { invoiceIndex: number })[]>(
    () =>
      document.Invoices.flatMap(({ Pages }, invoiceIndex) =>
        Pages.map((page) => ({ ...page, invoiceIndex })),
      ),
    [document.Invoices],
  );

  return (
    <Link
      to={`${DOCUMENTS_PAGE}/${document.ContainerId}`}
      className={`${classes.root} ${isSelected && classes.rootSelected}`}
      style={{ width: 256 * sizeFactor, height: 384 * sizeFactor }}
    >
      <div className={classes.pages}>
        {pages[0] && (
          <div className={classes.pagesPage}>
            <img src={generateImageURL(pages[0].PreviewSrc)} width="100%" />
            {showSelectCheckbox && (
              <span
                className={`${classes.checkBoxWrapper} ${isSelected && classes.checkBoxSelected}`}
                onClick={(e) => {
                  e.preventDefault();
                  selectDocument(document.ContainerId, document.Invoices[0].InvoiceId);
                }}
              >
                <span className={classes.checkBox}><CheckmarkIcon /></span>
              </span>
            )}
          </div>
        )}
      </div>
      <div className={classes.details}>
        <p className={classes.detailsText}>
          <FormattedMessage id="DOCUMENTS_CLIENT" />:  
        </p>
        <p className={classes.authorName}>{document.CreatedBy}</p>
        <FormattedDateTime value={document.Created}>
          {(text) => (
            <p className={classes.detailsText}>{text}</p>
          )}
        </FormattedDateTime>
      </div>
    </Link>
  );
};

const StyledDocumentsOverviewThumb = decorate(DocumentsOverviewThumb);
export { StyledDocumentsOverviewThumb as DocumentsOverviewThumb };
